<script lang="ts">
	import james from '$lib/assets/about/james.webp';
	import sean from '$lib/assets/about/sean.jpeg';
	import michele from '$lib/assets/about/michele.jpeg';
	import vlad from '$lib/assets/about/vlad.webp';
	import tahta from '$lib/assets/about/tahta.webp';

	const squadData = [
		{
			id: 1,
			photo: james,
			name: 'James',
			role: '-',
			bio: "James founded Planet League back in 2018 after writing a book about football and climate change. He has had a career in environmental finance and sustainability start-ups. He's a fan of Manchester United and Athletic Club Bilbao."
		},
		{
			id: 2,
			photo: sean,
			name: 'Sean',
			role: '-',
			bio: 'Sean has 20 years of experience in emerging technology and impact investing in 10+ African countries. He is the co-founder of ImpactScope, an award-winning impact technology company. Sean sings Arsenal and Hibs chants in the shower.'
		},
		{
			id: 3,
			photo: vlad,
			name: 'Vlad',
			role: '-',
			bio: 'Vlad has been with Planet League from the very beginning. He’s done it all — from reviewing user submissions to building new features and ensuring subscriptions are renewed on time. With a background in management consulting, he’s a go-to expert on sports, leagues, and competitions. His dream is to one day help his favourite PFC Slavia Sofia lift the Planet League Cup.'
		},
		{
			id: 4,
			photo: michele,
			name: 'Michele',
			role: '-',
			bio: 'Michele is very brainy Brescia Calcio fan. Like Sean, Michele is a co-founder of ImpactScope, where he designed a greenwashing detection platform used by the UK FCA. Michele has a PhD in Computer Science and MBA in Sustainable Business.'
		},
		{
			id: 5,
			photo: tahta,
			name: 'Tahta',
			role: '-',
			bio: "Tahta is the lead engineer who turns coffee into code and bugs into features. When he's not architecting Planet League, you'll find him passionately defending Barcelona's tiki-taka legacy and cheering for the Indonesian National Team."
		}
	];
</script>

<div class="pt-12 pb-24 md:pt-24 md:pb-32 space-y-12">
	<div class="font-title text-3xl md:text-5xl text-center">Meet the squad</div>
	<div class="flex flex-wrap justify-center gap-8">
		{#each squadData as member (member.name)}
			<div
				class="w-full sm:w-[300px] bg-white rounded-2xl p-6 space-y-2 shadow-pl transition-transform hover:-translate-y-2"
			>
				<div class="aspect-square bg-planet-blue/20 rounded-xl overflow-hidden">
					<img src={member.photo} alt={member.name} class="w-full h-full object-cover" />
				</div>
				<div class="font-title text-xl text-center pt-2">{member.name}</div>
				<!-- TODO: No role for now -->
				<div class="hidden text-sm text-planet-black3 font-bold leading-relaxed text-center">
					{member.role}
				</div>
				<p class="text-xs text-slate-500 leading-relaxed text-center">
					{member.bio}
				</p>
			</div>
		{/each}
	</div>
</div>
